import { render, staticRenderFns } from "./DropdownColumns.vue?vue&type=template&id=9a52ec36&"
import script from "./DropdownColumns.vue?vue&type=script&lang=js&"
export * from "./DropdownColumns.vue?vue&type=script&lang=js&"
import style0 from "./DropdownColumns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports